function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Error thrown when a commit to the grid fails.
 */
export class GridCommitError extends Error {
  constructor(message, options) {
    super(message, options);
    _defineProperty(this, "ranges", void 0);
    _defineProperty(this, "text", void 0);
    this.ranges = options === null || options === void 0 ? void 0 : options.ranges;
    this.text = options === null || options === void 0 ? void 0 : options.text;
    this.name = 'GridCommitError';
    this.cause = options === null || options === void 0 ? void 0 : options.cause;
  }
  toString() {
    // This gets displayed in the UI, so we want to keep it simple and readable by using just the message and cause
    return "".concat(this.message).concat(this.cause !== undefined ? ": ".concat(this.cause) : '');
  }
}
export default GridCommitError;
//# sourceMappingURL=GridCommitError.js.map